import Vue from 'vue';
const state = {
    paymentMethod: null
};

const mutations = {
    setPaymentMethod: (state, paymentMethod) => state.paymentMethod = paymentMethod
};

const getters = {
    paymentMethod: state => state.paymentMethod
};

const actions = {
    async GetShopPaymentMethodById ({ commit }, id) {
        try {
            const { data } = await Vue.axios.get(`/payments/context/${id}`);
            commit('setPaymentMethod', data[0]);
            return data[0];
        } catch {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `Error while fetching a payment method for id ${id}`
            });
        }
    },
    async SetShopPaymentMethod ({ commit }, { id , paymentType}) {
        try {
            await Vue.axios.post(`/payments/context`, { context: id, PaymentType: paymentType });
        } catch {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `Error while updating the payment for id ${id}`
            });
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
